import ClipLoader from "react-spinners/ClipLoader";
import "./LoadingComp.scss"

export default function LoadingComp({white = false}) {
    return (
        <div className={"loading-comp"}>
            <ClipLoader color={white ? '#ffffff' : '#6C5DD3'} loading={true} size={25} />
        </div>
    );
}